import { useRef, forwardRef } from 'react'
import classNames from 'classnames'
import { createUseStyles } from 'react-jss'
import DelayLink from '@/components/DelayLink'
import SimpleSplitText from '@/components/SimpleSplitText'
import ConditionalWrapper from '@/components/ConditionalWrapper'
import style from './style'

const useStyles = createUseStyles(style)

const BtnLink = forwardRef(({
  className,
  label,
  link,
  theme,
  icon,
  onClick,
}, ref) => {
  const classes = useStyles(style)
  const $label = useRef()

  const handleMouseEnter = () => $label.current.animateIn()
  const handleMouseLeave = () => $label.current.animateOut()

  return (
    <ConditionalWrapper
      condition={link}
      wrapper={(child) => <DelayLink to={link}>{child}</DelayLink>}
    >
      <button
        ref={ref}
        aria-label={label}
        className={classNames({
          [classes.root]: true,
          [className]: true,
          btnLink: true,
          [classes.btnDark]: theme === 'dark',
          [classes.btnGrey]: theme === 'grey',
          [classes.btnRed]: theme === 'red',
          [classes.btnGreen]: theme === 'green',
          [classes.btnLight]: theme === 'light',
          [classes.withIcons]: icon !== '',
        })}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={onClick}
      >
        {icon === 'back' && <svg><use xlinkHref="#ico-arrow-left" /></svg>}
        {icon === 'download' && <svg className="download"><use xlinkHref="#ico-arrow-left" /></svg>}
        <SimpleSplitText
          ref={$label}
          text={label}
          disableHover
          animation="linear"
        />
      </button>
    </ConditionalWrapper>
  )
})

BtnLink.defaultProps = {
  label: 'Scopri',
  theme: 'dark',
  icon: '',
  onClick: undefined,
}

export default BtnLink
